import {
  BarChart3,
  CalendarRange,
  ClipboardList,
  Clock,
  DollarSign,
  FolderKanban,
  GitBranch,
  Home,
  type LucideIcon,
  Receipt,
  Settings,
  Users,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  keywords?: string;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export function getNavSections(isAdmin: boolean): NavSection[] {
  const sections: NavSection[] = [
    {
      label: 'Workspace',
      items: [
        { to: '/', label: 'Dashboard', icon: Home, keywords: 'home overview' },
        { to: '/projects', label: 'Projects', icon: FolderKanban, keywords: 'clients' },
        { to: '/timesheets', label: 'My Timesheets', icon: Clock, keywords: 'hours log time' },
        { to: '/timeoff', label: 'Time Off', icon: CalendarRange, keywords: 'vacation leave pto' },
      ],
    },
  ];
  if (isAdmin) {
    sections.push(
      {
        label: 'Team',
        items: [
          { to: '/people', label: 'People', icon: Users, keywords: 'employees staff' },
          { to: '/timesheets/admin', label: 'All Timesheets', icon: ClipboardList },
          { to: '/timesheets/shadow', label: 'Shadow Timesheets', icon: GitBranch },
        ],
      },
      {
        label: 'Money',
        items: [
          {
            to: '/finance',
            label: 'Finance',
            icon: DollarSign,
            keywords: 'ledger income expenses',
          },
          { to: '/invoices', label: 'Invoices', icon: Receipt, keywords: 'billing' },
          { to: '/analytics', label: 'Analytics', icon: BarChart3, keywords: 'reports charts' },
        ],
      },
    );
  }
  return sections;
}

export const SETTINGS_ITEM: NavItem = {
  to: '/settings',
  label: 'Settings',
  icon: Settings,
  keywords: 'profile preferences',
};
